import React from 'react';
import moment from 'moment';
import FilterInputField from '../../components/TableFilter/ColumnsFilters/FilterInputField';
import ColumnSorting from '../../components/TableFilter/ColumnsFilters/ColumnSorting';
import FilterDatePicker from '../../components/TableFilter/ColumnsFilters/FilterDatePicker';
import FilterSelect from '../../components/TableFilter/ColumnsFilters/FilterSelect';
import FilterTreeSelect from '../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';

export function receivedVoucherColumn({ t, lang }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      sortable: true,
      filterable: false,
      width: 80,
      style: { textAlign: 'center' }
    },
    {
      Header: <ColumnSorting title={t('receivedVoucher_kindergartenVoucherQueueId')} name="id" />,
      accessor: 'id',
      width: 100,
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="id" type="number" />
    },
    {
      Header: (
        <ColumnSorting
          title={t('receivedVoucher_receiveDate')}
          name="createdAt"
        />
      ),
      accessor: 'createdAt',
      Cell: row =>
        row.original.createdAt
          ? moment(row.original.createdAt).format('DD.MM.YYYY HH:mm')
          : '',
      width: 120,
      sortable: false,
      style: { textAlign: 'center' },
      Filter: <FilterDatePicker name="createdAt" lang={lang} />
    },
    {
      Header: t('receivedVoucher_childIin'),
      accessor: 'childIin',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="childIin" type="number" />
    },
    {
      Header: t('receivedVoucher_childFullName'),
      accessor: 'childName',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="childFullName" />,
      Cell: ({ original }) =>
        `${original?.childSurname || ''} ${original?.childName ||
        ''} ${original?.childMiddleName || ''}`
    },
    {
      Header: (
        <ColumnSorting title={t('receivedVoucher_userCategory')} name="ageGroup" />
      ),
      accessor: 'ageGroup ',
      Cell: ({ original: { ageGroup } }) => ageGroup[`${lang}_name`],
      Filter: <FilterSelect name="ageGroup" dictCode="gu_age_group" lang={lang} />
    },
    {
      Header: (
        <ColumnSorting
          title={t('receivedVoucher_queuedType')}
          name="queuedType"
        />
      ),
      accessor: 'queuedType ',
      Cell: ({ original: { queuedType } }) => queuedType[`${lang}_name`],
      Filter: <FilterSelect name="queuedType" dictCode="gu_queued_type" lang={lang} />
    },
    {
      Header: (
        <ColumnSorting
          title={t('receivedVoucher_arriveDeadline')}
          name="arriveDeadline"
        />
      ),
      accessor: 'arriveDeadline',
      Cell: row =>
        row.original.arriveDeadline
          ? moment(row.original.arriveDeadline).format('DD.MM.YYYY HH:mm')
          : '',
      width: 120,
      sortable: false,
      style: { textAlign: 'center' },
      Filter: <FilterDatePicker name="arriveDeadline" lang={lang} />
    },
    {
      Header: (
        <ColumnSorting title={t('receivedVoucher_status')} name="status" />
      ),
      accessor: 'status ',
      Cell: ({ original: { appStatusWebStatus } }) =>
        appStatusWebStatus[`${lang}_name`],
      Filter: (
        <FilterSelect name="status" dictCode="voucher_status_web" lang={lang} />
      )
    },
    {
      Header: t('receivedVoucher_bulletinId'),
      accessor: 'bulletinId',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="bulletinId" type="number" />
    },
    {
      Header: t('receivedVoucher_serviceProviderLocation'),
      accessor: 'queuedRegion',
      Cell: ({ original: { queuedRegion } }) =>
        queuedRegion[`${lang}_name`],
      Filter: (
        <FilterTreeSelect lookupId="60" name="queuedRegion" lang={lang} />
      )
    },
    {
      Header: t('receivedVoucher_serviceProviderBin'),
      accessor: 'serviceProviderBin',
      minWidth: 150,
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="serviceProviderBin" type="number" />
    }
  ];
}
